
import { ShoppingCart } from "lucide-react";
import { Button } from "@/components/ui/button";

interface CartIconProps {
  itemCount: number;
  onClick: () => void;
}

export function CartIcon({ itemCount, onClick }: CartIconProps) {
  return (
    <Button 
      onClick={onClick}
      size="lg" 
      className="fixed bottom-5 right-5 rounded-full w-16 h-16 shadow-lg flex items-center justify-center"
    >
      <ShoppingCart className="h-6 w-6" />
      {itemCount > 0 && (
        <span className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold">
          {itemCount}
        </span>
      )}
    </Button>
  );
}
